

<div class="card mb-3">
    <div class="card-header d-flex flex-row justify-content-between">        
        <h2 class="card-title mb-0">Payment Gateway Log</h2>
    </div>
    <div class="p-3">
        <div class="d-flex flex-row flex-wrap gap-3 align-items-end mb-3">
            <div>
                <label for="name" class="form-label">Date From</label>
                <input type="date" class="form-control form-contrl-lg" [(ngModel)]="data.date_from" />
            </div>
            <div>
                <label for="name" class="form-label">Date To</label>
                <input type="date" class="form-control form-contrl-lg" [(ngModel)]="data.date_to" />
            </div>
            <div>
                <label for="name" class="form-label">Player Code</label>
                <input type="text" class="form-control form-contrl-lg" [(ngModel)]="data.code" />
            </div>
            <div>
                <label for="name" class="form-label">Player Mobile</label>
                <input type="text" class="form-control form-contrl-lg" [(ngModel)]="data.mobile" placeholder="Include Country Code" />
            </div>
            <div>
                <label for="status" class="form-label">Status</label>
                <select class="form-select" [(ngModel)]="data.status">
                    <option value="">All</option>
                    <option value="1">Success</option>
                    <option value="0">Failed</option>
                    <option value="2">Pending</option>
                </select>
            </div>
            <div>
                <label for="gateway" class="form-label">Provider</label>
                <select class="form-select" [(ngModel)]="data.gateway_id">
                    <option value="">All</option>
                    <option *ngFor="let provider of providers" [value]="provider.id">{{provider.name}}</option>
                </select>
            </div>
            <div>
                <label for="name" class="form-label">Match</label>
                <select class="form-select" [(ngModel)]="data.match">
                    <option value="exact">Exact</option>
                    <option value="approx">Approximate</option>
                </select>
            </div>
            
            <button class="btn btn-primary" (click)="filter()">Filter</button>
        </div>
    </div>
</div>

<app-tablev2 #table></app-tablev2>
